/* eslint-disable */
import React, { useState } from 'react';
import moment from 'moment';
import Checkbox from '../checkbox/Checkbox';
import EnterIcon from './img/enter.svg';
import ColoredLine from '../coloredLine/ColoredLine';
import UnreadIcon from './img/unread.svg';
import GeofenceAlertIcon from './img/geofenceAlert.svg';
import UnpluggedAlertIcon from './img/unpluggedStatus.svg';
import AssetStatusAlertIcon from './img/assetStatus.svg';
import OverspeedingAlertIcon from './img/overspeeding.svg';
import BatteryStatusAlertIcon from './img/batteryStatus.svg'
import EVRangeAlertIcon from './img/evRangeAlert.svg';
import EVChargingAlertIcon from './img/evChargingAlert.svg';
import EVBatteryTemperatureAlertIcon from './img/evBatteryTemperatureAlert.svg';
import EVBatteryStateOfHealthIcon from './img/batteryHealth.svg';
import UpIcon from './img/upIcon.svg';
import DownIcon from './img/downIcon.svg';

import './notificationList.css';

const NotificationList = (props) => {
    const {
        data, selectedCheckboxes, setSelectedCheckboxes, handleChecked,
    } = props;
    const [expandedNotifications, setExpandedNotifications] = useState({});

    const checkAlertType = (type) => {
        switch (type) {
            case 101:
                return 'Geofence Alert';
            case 102:
                return 'Unplugged Status Alert';
            case 103:
                return 'Asset Status Alert';
            case 104:
                return 'Speeding Alert';
            case 105:
                return 'Battery Status Alert';
            case 106:
                return 'EV Range Alert';
            case 107:
                return 'EV Charging Alert';
            case 108:
                return 'EV Battery Temperature Alert';
            case 109:
                return 'EV Battery SoH Alert';
            default:
                return null;
        }
    };

    const alertIcon = {
        101: {
            icon: GeofenceAlertIcon,
            alt: 'geofence-icon',
        },
        102: {
            icon: UnpluggedAlertIcon,
            alt: 'unplugged-icon',
        },
        103: {
            icon: AssetStatusAlertIcon,
            alt: 'asset-status-icon',
        },
        104: {
            icon: OverspeedingAlertIcon,
            alt: 'speeding-icon',
        },
        105: {
            icon: BatteryStatusAlertIcon,
            alt: 'battery-status-icon',
        },
        106: {
            icon: EVRangeAlertIcon,
            alt: 'ev-range-icon',
        },
        107: {
            icon: EVChargingAlertIcon,
            alt: 'ev-charging-alert-icon',
        },
        108: {
            icon: EVBatteryTemperatureAlertIcon,
            alt: 'ev-battery-status-icon',
        },
        109: {
            icon: EVBatteryStateOfHealthIcon,
            alt: 'ev-battery-state-of-health-icon',
        },
    };

    // Toggle expanded/collapsed state
    const toggleExpand = (oid) => {
        setExpandedNotifications((prevState) => ({
            ...prevState,
            [oid]: !prevState[oid],
        }));
    };

    return (
        <div className="notificationList-body">
            {data && data.map((x, index) => {
                const { icon, alt } = alertIcon[x.type] || {
                    icon: EnterIcon,
                    alt: 'default-icon',
                };
                return (
                    <React.Fragment key={index}>
                        <div className="notification-feed">
                            <Checkbox
                              checked={!!selectedCheckboxes[x.oid]}
                              width="20px"
                              height="20px"
                              onClick={() => handleChecked(x.oid)}
                              value={x.oid}
                            />
                            <div className="notificationFeed-container">
                                <div className="notificationFeed-body">
                                    <div className="notificationFeed-body-header">
                                        {x.read === false && (
                                            <img
                                              src={UnreadIcon}
                                              alt="unread-icon"
                                              loading="lazy"
                                              className="unread-icon"
                                            />
                                        )}
                                        <img src={icon} alt={alt} loading="lazy" />
                                        <div className="notification-type">
                                            {checkAlertType(x.type)}
                                        </div>
                                        <div className="notification-time">
                                            {moment(x.timestamp).fromNow()}
                                        </div>
                                        <div
                                            className="expand-icon"
                                            onClick={() => toggleExpand(x.oid)}
                                            style={{ cursor: 'pointer' }}
                                        ></div>
                                    </div>
                                    <div className="notificationFeed-body-content">
                                        <div className="notificationFeed-body-text-container">
                                            <div
                                                className="notificationFeed-body-text message"
                                                onClick={() => toggleExpand(x.oid)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                {x.message}
                                                <img
                                                    src={expandedNotifications[x.oid] ? UpIcon : DownIcon}
                                                    alt={expandedNotifications[x.oid] ? 'up-icon' : 'down-icon'}
                                                    loading="lazy"
                                                    className="up-down-icon"
                                                />
                                            </div>
                                            {expandedNotifications[x.oid] && (
                                                <div className="expanded-content">
                                                    {x.type === 101 ? (
                                                        // Geofence Alert Body
                                                        <>
                                                            {x.policyName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Alert Policy: ${x.policyName}`}
                                                                </div>
                                                            )}
                                                            {x.areaName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Area Name: ${x.areaName}`}
                                                                </div>
                                                            )}
                                                            {x.geofenceName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Geofence Name: ${x.geofenceName}`}
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : x.type === 102 ? (
                                                        // Unplugged Status Alert Body
                                                        <>
                                                            {x.deviceSerial && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Device Serial: ${x.deviceSerial}`}
                                                                </div>
                                                            )}
                                                            {x.assetName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Asset Name: ${x.assetName}`}
                                                                </div>
                                                            )}
                                                            {x.assetType && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Asset Type: ${x.assetType}`}
                                                                </div>
                                                            )}
                                                            {x.agencyName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Agency Name: ${x.agencyName}`}
                                                                </div>
                                                            )}
                                                            {x.areaName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Area Name: ${x.areaName}`}
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : x.type === 103 ? (
                                                        // Asset Status Alert Body (Type 103)
                                                        <>
                                                            {x.assetName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Asset Name: ${x.assetName}`}
                                                                </div>
                                                            )}
                                                            {x.assetTrigger && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Asset Trigger: ${x.assetTrigger}`}
                                                                </div>
                                                            )}
                                                            {/* {x.assetStatus && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Asset Status: ${x.assetStatus}`}
                                                                </div>
                                                            )} */}
                                                            {x.policyName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Alert Policy: ${x.policyName}`}
                                                                </div>
                                                            )}
                                                            {x.lastSeenLocation && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Last Seen Location: ${x.lastSeenLocation}`}
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : x.type === 104 ? (
                                                        // Speeding Alert Body (Type 104)
                                                        <>
                                                            {x.assetName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Asset Name: ${x.assetName}`}
                                                                </div>
                                                            )}
                                                            {x.speedingType && (
                                                            <div className="notificationFeed-body-text">
                                                                {`Speeding Type: ${x.speedingType?.charAt(0).toUpperCase() + x.speedingType?.slice(1)}`}
                                                            </div>
                                                            )}
                                                            {x.speed && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Speed: ${x.speed} km/h`}
                                                                </div>
                                                            )}
                                                            {x.policyName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Alert Policy: ${x.policyName}`}
                                                                </div>
                                                            )}
                                                            {x.lastSeenLocation && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Last Seen Location: ${x.lastSeenLocation}`}
                                                                </div>
                                                            )}
                                                        </>
                                                    ) :  x.type === 105 ? (
                                                        // Battery Status Alert Body (Type 105)
                                                        <>
                                                            {x.assetName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Asset Name: ${x.assetName}`}
                                                                </div>
                                                            )}
                                                            {x.batteryTrigger && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Battery Trigger: ${x.batteryTrigger}`}
                                                                </div>
                                                            )}
                                                            {x.batteryLevel != null && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Battery Level: ${x.batteryLevel}%`}
                                                                </div>
                                                            )}
                                                            {x.voltage && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Voltage: ${x.voltage} V`}
                                                                </div>
                                                            )}
                                                            {x.batteryThreshold && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Battery Threshold: ${x.batteryThreshold}${x.batteryTrigger === 'Overvoltage' ? 'V' : '%'}`}
                                                                </div>
                                                            )}
                                                            {x.policyName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Alert Policy: ${x.policyName}`}
                                                                </div>
                                                            )}
                                                        </>
                                                    ) :  x.type === 106 ? (
                                                        // EV Range Alert Body
                                                        <>
                                                            {x.deviceSerial && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Device Serial: ${x.deviceSerial}`}
                                                                </div>
                                                            )}
                                                            {x.rangeThreshold && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Range Remain: ${x.rangeThreshold}`}
                                                                </div>
                                                            )}
                                                            {x.agencyName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Agency Name: ${x.agencyName}`}
                                                                </div>
                                                            )}
                                                            {x.policyName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Alert Policy: ${x.policyName}`}
                                                                </div>
                                                            )}
                                                            {x.assetName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Asset Name: ${x.assetName}`}
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : x.type === 107 ? (
                                                        // EV Charging Alert Body
                                                        <>
                                                            {x.deviceSerial && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Device Serial: ${x.deviceSerial}`}
                                                                </div>
                                                            )}
                                                            {x.batteryLevel && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Battery Level: ${x.batteryLevel}%`}
                                                                </div>
                                                            )}
                                                            {x.policyName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Alert Policy: ${x.policyName}`}
                                                                </div>
                                                            )}
                                                            {x.areaName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Area Name: ${x.areaName}`}
                                                                </div>
                                                            )}
                                                            {x.geofenceName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Geofence Name: ${x.geofenceName}`}
                                                                </div>
                                                            )}
                                                        </>
                                                    ) :  x.type === 108 ? (
                                                        // EV Battery Temperature Alert Body (Type 108)
                                                        <>
                                                            {x.assetName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Asset Name: ${x.assetName}`}
                                                                </div>
                                                            )}
                                                            {x.batteryTemp && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Battery Temperature: ${x.batteryTemp}°C`}
                                                                </div>
                                                            )}
                                                            {x.policyName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Alert Policy: ${x.policyName}`}
                                                                </div>
                                                            )}
                                                        </>
                                                    ):  x.type === 109 ? (
                                                        // EV Battery State of Health Alert Body (Type 109)
                                                        <>
                                                            {x.assetName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Asset Name: ${x.assetName}`}
                                                                </div>
                                                            )}
                                                            {x.batterySoH && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Battery State of Health: ${x.batterySoH}`}
                                                                </div>
                                                            )}
                                                            {x.batteryStateOfHealth && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Battery State of Health: ${x.batteryStateOfHealth}`}
                                                                </div>
                                                            )}
                                                            {x.policyName && (
                                                                <div className="notificationFeed-body-text">
                                                                    {`Alert Policy: ${x.policyName}`}
                                                                </div>
                                                            )}
                                                        </>
                                                    ): null } 
                                                    <div className="notificationFeed-body-text">
                                                        {`Agency Local Time: ${moment(x.timestamp).format(
                                                            'DD MMM YYYY h:mm a'
                                                        )}`}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ColoredLine />
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default NotificationList;
